import { ServiceRequest } from "@/utils/ServiceRequest/service-request";
import { ReadonlyURLSearchParams } from "next/navigation";
import React from "react";
import { useTranslation } from "react-i18next";

export const useName = (search: ReadonlyURLSearchParams) => {
  const { t } = useTranslation();
  const [name, setName] = React.useState("");

  React.useEffect(() => {
    const { displayServiceName } = ServiceRequest(search);
    setName(displayServiceName.getName(t));
  }, [search, t]);

  return name;
};
